import { render, staticRenderFns } from "./TapDisburstmentRequestStudentEligibilityApproved.vue?vue&type=template&id=214f860a&"
import script from "./TapDisburstmentRequestStudentEligibilityApproved.vue?vue&type=script&lang=js&"
export * from "./TapDisburstmentRequestStudentEligibilityApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports